import React from "react";
import CreditCard from "./CreditCard";
import {cx} from "../../lib/ClassSet";
import "./CreditCardWithSelection.css";

const CreditCardWithSelection = (props) => {

  let fn = () => props.onSelect(props.id);
  let classes = cx({
    "CreditCardWithSelection": true,
    "u-selected": props.selected
  })
  return (
    <div className={classes} onClick={fn}>
      <div className="radiobox">
        <div className="tick" />
      </div>
      <CreditCard card={props.card} />
    </div>
  )

}

export default CreditCardWithSelection;